const prefix = '/api/v1';

export const ApiRoutes = {
    activeEmployees: {
        query: () => `${prefix}/activeEmployees/query`,
        export: () => `${prefix}/activeEmployees/export`,
    },
    address: {
        create: () => `${prefix}/address`,
        update: (addressId) => `${prefix}/address/${addressId}`,
    },
    adminTool: {
        search: () => `${prefix}/admintools/search`,
        getAdminToolHistory: (id) =>
            `${prefix}/admintoolHistory/getAdminToolHistory/${id}`,
        moveTimesheetToJob: () => `${prefix}/admintool/moveTimesheetToJob`,
        swapContractChargeType: () =>
            `${prefix}/admintool/swapContractChargeType`,
        syncTimesheetContractBilling: () =>
            `${prefix}/admintool/syncTimesheetContractBilling`,
        addJobCity: () => `${prefix}/admintool/addJobCity`,
        rejectBillingPayroll: () => `${prefix}/admintool/rejectBillingPayroll`,
        removeCharges: () => `${prefix}/admintool/removeCharges`,
    },
    auth: {
        permissions: () => `${prefix}/authorization/permissions`,
        profile: () => `${prefix}/authorization/profile`,
        roles: () => `${prefix}/authorization/roles`,
        groups: () => `${prefix}/authorization/groups`,
        confirmPhone: (code) => `${prefix}/authorization/confirmPhone/${code}`,
    },
    billing: {
        search: () => `${prefix}/billings/search`,
        excelExport: () => `${prefix}/billings/excelExport`,
        export: () => `${prefix}/billings/export`,
        approve: () => `${prefix}/billings/approve`,
        reject: () => `${prefix}/billings/reject`,
        adminReject: () => `${prefix}/billings/adminReject`,
        needsAdminReject: (id) => `${prefix}/billings/needsAdminReject/${id}`,
        download: (id) => `${prefix}/billing/download/${id}`,
        setEmergency: () => `${prefix}/billing/setEmergency`,
    },
    billingChargeCategory: {
        edit: () => `${prefix}/billingChargeCategory/edit`,
        search: () => `${prefix}/billingChargeCategories/search`,
        excelExport: () => `${prefix}/billingChargeCategories/excelExport`,
        export: () => `${prefix}/billingChargeCategories/export`,
        approve: () => `${prefix}/billingChargeCategories/approve`,
        reject: () => `${prefix}/billingChargeCategories/reject`,
        process: () => `${prefix}/billingChargeCategories/process`,
        download: (id) => `${prefix}/billingChargeCategory/download/${id}`,
        setEmergency: () => `${prefix}/billingChargeCategory/setEmergency`,
        slideout: (billingId) =>
            `${prefix}/billingChargeCategory/${billingId}/slideout`,
        billperiods: (billingId) =>
            `${prefix}/billingChargeCategory/${billingId}/billperiods`,
    },
    billingCharge: {
        edit: () => `${prefix}/billingCharge/edit`,
        search: () => `${prefix}/billingCharges/search`,
        excelExport: () => `${prefix}/billingCharges/excelExport`,
        export: () => `${prefix}/billingCharges/export`,
        approve: () => `${prefix}/billingCharges/approve`,
        reject: () => `${prefix}/billingCharges/reject`,
        adminReject: () => `${prefix}/billingCharges/adminReject`,
        needsAdminReject: (id) =>
            `${prefix}/billingCharges/needsAdminReject/${id}`,
        process: () => `${prefix}/billingCharges/process`,
        download: (id) => `${prefix}/billingCharge/download/${id}`,
        setEmergency: () => `${prefix}/billingCharge/setEmergency`,
        slideout: (billingId) =>
            `${prefix}/billingCharge/${billingId}/slideout`,
        unapprove: (billingDetailId) =>
            `${prefix}/billingCharge/unapprove/${billingDetailId}`,
        void: () => `${prefix}/billingCharge/void`,
        unvoid: (billingId) => `${prefix}/billingCharge/unvoid/${billingId}`,
    },
    billingRate: {
        search: () => `${prefix}/billingRates/search`,
        getGridPermissions: () => `${prefix}/billingRates/getGridPermissions`,
        excelExport: () => `${prefix}/billingRates/excelExport`,
        chargeTypeBillingRateHistory: (chargeTypeId) =>
            `${prefix}/billingRates/chargeTypeBillingRateHistory/${chargeTypeId}`,
        companyBillingRateHistory: () =>
            `${prefix}/billingRates/companyBillingRateHistory`,
    },
    billingIssues: {
        search: () => `${prefix}/billingIssues/search`,
        reject: () => `${prefix}/billingIssues/reject`,
        invoiceReject: () => `${prefix}/billingIssues/invoiceReject`,
        accept: () => `${prefix}/billingIssues/accept`,
        invoiceAccept: () => `${prefix}/billingIssues/invoiceAccept`,
        reply: () => `${prefix}/billingIssues/reply`,
        messages: (billingId) => `${prefix}/billingIssues/${billingId}`,
        invoiceMessages: () => `${prefix}/billingIssues/invoiceMessages`,
        excelExport: () => `${prefix}/billingIssues/excelExport`,
    },
    brokerCapacityOverview: {
        forDate: (brokerId, date) =>
            `${prefix}/brokerCapacityOverview/${brokerId}/${date}`,
    },
    brokerDefaultCapacity: {
        get: (brokerId) => `${prefix}/brokerDefaultCapacity/${brokerId}`,
        upsert: () => `${prefix}/brokerDefaultCapacity/upsert`,
    },
    brokerDateCapacity: {
        getRange: (brokerId, startApiDate, endApiDate) =>
            `${prefix}/brokerDateCapacities/${brokerId}/${startApiDate}/${endApiDate}`,
        upsert: () => `${prefix}/brokerDateCapacity/upsert`,
    },
    brokerDateHashCode: {
        get: (brokerId, asOfDate) =>
            `${prefix}/brokerDateHashCodes/${brokerId}/${asOfDate}`,
    },
    calendar: {
        get: (start, end) => `${prefix}/calendar/${start}/${end}`,
        timesheetStatuses: (start, end) =>
            `${prefix}/calendar/timesheetStatuses/${start}/${end}`,
    },
    chargeView: {
        search: () => `${prefix}/chargeViews/search`,
        excelExport: () => `${prefix}/chargeViews/excelExport`,
        hoursReportCompanies: () =>
            `${prefix}/chargeViews/hoursReportCompanies`,
        hoursReportExport: () => `${prefix}/chargeViews/hoursReportExport`,
    },
    chargeType: {
        all: () => `${prefix}/chargeTypes`,
        search: () => `${prefix}/chargeTypes/search`,
        byCustomer: (customerId) =>
            `${prefix}/chargeTypes/customer${
                customerId ? `/${customerId}` : ''
            }`,
        byCustomerBillable: (customerId) =>
            `${prefix}/chargeTypes/customerBillable${
                customerId ? `/${customerId}` : ''
            }`,
        byId: (chargeTypeId) => `${prefix}/chargeType/${chargeTypeId}`,
        create: () => `${prefix}/chargeType`,
        update: (chargeTypeId) => `${prefix}/chargeType/${chargeTypeId}`,
        delete: (chargeTypeId) => `${prefix}/chargeType/${chargeTypeId}`,
        byContract: (id) => `${prefix}/chargeTypes/contract/${id}`,
        bySetupTypes: () => `${prefix}/chargeTypes/bySetupTypes`,
        setupSurcharges: () => `${prefix}/chargeTypes/setupSurcharges`,
        byTimesheetNumber: (timesheetNum) =>
            `${prefix}/chargeTypes/byTimesheet/${timesheetNum}`,
        byContractId: (contractId) =>
            `${prefix}/chargeTypes/byContractId/${contractId}`,
    },
    chargeTypeStatus: {
        all: () => `${prefix}/chargeTypeStatuses`,
        search: () => `${prefix}/chargeTypeStatuses`,
        byId: (chargeTypeStatusId) =>
            `${prefix}/chargeTypeStatus/${chargeTypeStatusId}`,
        create: () => `${prefix}/chargeTypeStatus`,
        update: (chargeTypeStatusId) =>
            `${prefix}/chargeTypeStatus/${chargeTypeStatusId}`,
        delete: (chargeTypeStatusId) =>
            `${prefix}/chargeTypeStatus/${chargeTypeStatusId}`,
    },
    chargeTypeUnit: {
        all: () => `${prefix}/chargeTypeUnits`,
        search: () => `${prefix}/chargeTypeUnits/search`,
        byId: (chargeTypeUnitId) =>
            `${prefix}/chargeTypeUnit/${chargeTypeUnitId}`,
        create: () => `${prefix}/chargeTypeUnit`,
        update: (chargeTypeUnitId) =>
            `${prefix}/chargeTypeUnit/${chargeTypeUnitId}`,
        delete: (chargeTypeUnitId) =>
            `${prefix}/chargeTypeUnit/${chargeTypeUnitId}`,
    },
    chargeTypeGroup: {
        search: () => `${prefix}/chargeTypeGroups/search`,
        byId: (chargeTypeGroupId) =>
            `${prefix}/chargeTypeGroup/${chargeTypeGroupId}`,
        create: () => `${prefix}/chargeTypeGroup`,
        update: (chargeTypeGroupId) =>
            `${prefix}/chargeTypeGroup/${chargeTypeGroupId}`,
        delete: (chargeTypeGroupId) =>
            `${prefix}/chargeTypeGroup/${chargeTypeGroupId}`,
        byContract: (id) => `${prefix}/chargeTypeGroups/contract/${id}`,
    },
    company: {
        all: () => `${prefix}/companies`,
        create: () => `${prefix}/company`,
        invoicing: () => `${prefix}/companies/invoicing`,
        byId: (companyId) => `${prefix}/company/${companyId}`,
        locations: (companyId) => `${prefix}/company/${companyId}/locations`,
        search: () => `${prefix}/companies/search`,
        excelExport: () => `${prefix}/companies/excelExport`,
        types: () => `${prefix}/company/types`,
        customerCompanies: (companyId) =>
            `${prefix}/companies/customers/${companyId}`,
        customerOperationsCentersCompanies: (customerCompanyId) =>
            `${prefix}/companies/customerOperationCenters/${customerCompanyId}`,
        payrollCompanies: () => `${prefix}/companies/payroll`,
        dispatchCompanies: () => `${prefix}/companies/dispatch`,
        dispatchCompaniesByCompanyId: (companyId) =>
            `${prefix}/companies/dispatch/${companyId}`,
        foremen: (companyId) => `${prefix}/company/${companyId}/foremen`,
        contacts: (companyId) => `${prefix}/company/${companyId}/contacts`,
        allowAlternativePayroll: (companyId) =>
            `${prefix}/company/${companyId}/allowAlternativePayroll`,
        operationsCentersApply: (companyId) =>
            `${prefix}/company/${companyId}/operationsCentersApply`,
        defaultTerms: (companyId) =>
            `${prefix}/company/defaultTerms/${companyId}`,
        defaultMapping: (companyId) =>
            `${prefix}/company/defaultMapping/${companyId}`,
        defaultChargeTypeGroups: (companyId) =>
            `${prefix}/companies/defaultChargeTypeGroups/${companyId}`,
        parentCompanies: () => `${prefix}/companies/parentCompanies`,
        getIsBroker: (companyId) =>
            `${prefix}/company/getIsBroker/${companyId}`,
    },
    companyBillingGroups: {
        search: () => `${prefix}/companies/searchBillingGroups`,
        byId: (billingGroupId) =>
            `${prefix}/company/billingGroup/${billingGroupId}`,
        update: (billingGroupId) =>
            `${prefix}/company/billingGroup/${billingGroupId}`,
    },
    companyType: {
        search: () => `${prefix}/companyTypes/search`,
        byId: (companyTypeId) => `${prefix}/companyType/${companyTypeId}`,
        create: () => `${prefix}/companyType`,
        update: (companyTypeId) => `${prefix}/companyType/${companyTypeId}`,
        delete: (companyTypeId) => `${prefix}/companyType/${companyTypeId}`,
    },
    complianceTypes: {
        all: () => `${prefix}/complianceTypes`,
        allEquipmentComplianceTypes: () =>
            `${prefix}/complianceTypes/getComplianceTypesForEquipment`,
        allEmployeeComplianceTypes: () =>
            `${prefix}/complianceTypes/getComplianceTypesForEmployees`,
        forAllDispatches: () => `${prefix}/complianceTypes/forAllDispatches`,
        search: () => `${prefix}/complianceTypes/search`,
        byId: (complianceTypeId) =>
            `${prefix}/complianceType/${complianceTypeId}`,
        create: () => `${prefix}/complianceType/create`,
        update: () => `${prefix}/complianceType/update`,
        delete: (complianceTypeId) =>
            `${prefix}/complianceType/${complianceTypeId}`,
    },
    contactActivity: {
        byId: (contactActivityId) =>
            `${prefix}/contactActivity/${contactActivityId}`,
        update: (contactActivityId) =>
            `${prefix}/contactActivity/${contactActivityId}`,
        create: () => `${prefix}/contactActivity`,
        search: () => `${prefix}/contactActivities/search`,
        delete: (contactActivityId) =>
            `${prefix}/contactActivity/${contactActivityId}`,
        excelExport: () => `${prefix}/contactActivities/excelExport`,
    },
    contract: {
        byId: (contractId) => `${prefix}/contract/${contractId}`,
        filteredRates: (contractId, dateStr) =>
            `${prefix}/contract/${contractId}/${dateStr}`,
        update: (contractId) => `${prefix}/contract/${contractId}`,
        create: () => `${prefix}/contract`,
        search: () => `${prefix}/contracts/search`,
        searchExport: () => `${prefix}/contracts/searchExport`,
        getGridPermissions: () => `${prefix}/contracts/getGridPermissions`,
        userHasSelfDispatching: () => `${prefix}/contracts/hasSelfDispatching`,
        getNonFlagging: () => `${prefix}/contracts/getNonFlagging`,
        getSelfDispatching: () => `${prefix}/contracts/selfDispatching`,
        moveTimesheets: () => `${prefix}/contract/moveTimesheets`,
        all: () => `${prefix}/contracts`,
        forCompany: (companyId) =>
            `${prefix}/contracts/forCompany/${companyId}`,
        validateJobNumber: (jobNumber) =>
            `${prefix}/contract/validateJobNumber/${jobNumber}`,
        getSelectable: () => `${prefix}/contracts/getSelectable`,
    },
    contractCompliances: {
        byId: (contractComplianceId) =>
            `${prefix}/contractCompliance/${contractComplianceId}`,
        create: () => `${prefix}/contractCompliance`,
        update: (contractComplianceId) =>
            `${prefix}/contractCompliance/${contractComplianceId}`,
        delete: (contractComplianceId) =>
            `${prefix}/contractCompliance/${contractComplianceId}`,
        allForContract: (contractId) =>
            `${prefix}/contractCompliances/getCompliancesForContract/${contractId}`,
    },
    contractTemplate: {
        create: () => `${prefix}/contractTemplate`,
        byId: (id) => `${prefix}/contractTemplate/${id}`,
        search: () => `${prefix}/contractTemplates/search`,
        names: () => `${prefix}/contractTemplates`,
    },
    contractTemplateCompliances: {
        byId: (contractTemplateComplianceId) =>
            `${prefix}/contractTemplateCompliance/${contractTemplateComplianceId}`,
        create: () => `${prefix}/contractTemplateCompliance`,
        update: (contractTemplateComplianceId) =>
            `${prefix}/contractTemplateCompliance/${contractTemplateComplianceId}`,
        delete: (contractTemplateComplianceId) =>
            `${prefix}/contractTemplateCompliance/${contractTemplateComplianceId}`,
        allForContractTemplate: (contractTemplateId) =>
            `${prefix}/contractTemplateCompliances/getCompliancesForContractTemplate/${contractTemplateId}`,
    },
    contractStatus: {
        search: () => `${prefix}/contractStatuses/search`,
        byId: (contractStatusId) =>
            `${prefix}/contractStatus/${contractStatusId}`,
        create: () => `${prefix}/contractStatus`,
        update: (contractStatusId) =>
            `${prefix}/contractStatus/${contractStatusId}`,
        delete: (contractStatusId) =>
            `${prefix}/contractStatus/${contractStatusId}`,
    },
    crew: {
        search: () => `${prefix}/crews/search`,
        excelExport: () => `${prefix}/crews/excelExport`,
        get: (crewId) => `${prefix}/crew/${crewId}`,
        all: () => `${prefix}/crews`,
        create: () => `${prefix}/crew/create`,
        update: () => `${prefix}/crew/update`,
        delete: (crewId) => `${prefix}/crew/delete/${crewId}`,
    },
    division: {
        search: () => `${prefix}/divisions/search`,
        get: (divisionId) => `${prefix}/division/${divisionId}`,
        all: () => `${prefix}/divisions`,
        create: () => `${prefix}/division/create`,
        update: () => `${prefix}/division/update`,
    },
    customers: {
        all: (companyId) => `${prefix}/customers/${companyId}`,
    },
    dailyAttendanceEvent: {
        all: () => `${prefix}/dailyAttendanceEvents`,
        byId: (id) => `${prefix}/dailyAttendanceEvent/${id}`,
        create: () => `${prefix}/dailyAttendanceEvent/create`,
        update: () => `${prefix}/dailyAttendanceEvent/update`,
        search: () => `${prefix}/dailyAttendanceEvents/search`,
        delete: (id) => `${prefix}/dailyAttendanceEvent/${id}`,
    },
    dispatch: {
        viewModel: () => `${prefix}/dispatch/viewmodel`,
        staff: () => `${prefix}/dispatch/staff`,
        equipment: () => `${prefix}/dispatch/equipment`,
        brokers: () => `${prefix}/dispatch/brokers`,
        crews: () => `${prefix}/dispatch/crews`,
        jobs: () => `${prefix}/dispatch/jobs`,
        cancelledJobs: () => `${prefix}/dispatch/cancelledJobs`,
        saveAssignment: () => `${prefix}/dispatch/saveAssignment`,
        removeAssignment: (jobAssignmentId) =>
            `${prefix}/dispatch/removeAssignment/${jobAssignmentId}`,
        removeAllAssignments: () => `${prefix}/dispatch/removeAllAssignments`,
        cancelAssignment: () => `${prefix}/dispatch/cancelAssignment`,
        cancelJob: () => `${prefix}/dispatch/cancelJob`,
        setCrewLead: (jobAssignmentId) =>
            `${prefix}/dispatch/crewLead/${jobAssignmentId}`,
        setEquipmentAssignedEmployee: (jobAssignmentId, employeeId) =>
            `${prefix}/dispatch/setEquipmentAssignedEmployee/${jobAssignmentId}/${employeeId}`,
        setEquipmentAssignedEquipment: (jobAssignmentId, equipmentId) =>
            `${prefix}/dispatch/setEquipmentAssignedEquipment/${jobAssignmentId}/${equipmentId}`,
    },
    employee: {
        toggleImpersonation: () => `${prefix}/employee/toggleImpersonation`,
        cancelImpersonation: () => `${prefix}/employee/cancelImpersonation`,
        suggestUsername: (name) => `${prefix}/employee/suggestUsername/${name}`,
        byId: (empId) => `${prefix}/employee/${empId}`,
        create: () => `${prefix}/employee`,
        update: (empId) => `${prefix}/employee/${empId}`,
        payRate: {
            create: (empId) => `${prefix}/employee/${empId}/payRate`,
            update: (empId, payRateId) =>
                `${prefix}/employee/${empId}/payRate/${payRateId}`,
        },
        groups: {
            all: () => `${prefix}/employees`,
        },
        rosterView: (empId) => `${prefix}/employee/${empId}/roster`,
    },
    employees: {
        all: () => `${prefix}/employees`,
        associatedWithContactActivity: () =>
            `${prefix}/employees/associatedWithContactActivity`,
        byCompany: (companyId) => `${prefix}/employees/${companyId}`,
        byGroups: () => `${prefix}/employees/byGroups`,
        byDispatchLocationAndEquipmentType: (
            dispatchLocationId,
            equipmentTypeId
        ) =>
            `${prefix}/employees/byDispatchLocationAndEquipmentType/${dispatchLocationId}/${equipmentTypeId}`,
        search: () => `${prefix}/employees/search`,
        roster: () => `${prefix}/employees/roster`,
        rosterExport: () => `${prefix}/employees/rosterExport`,
        excelExport: () => `${prefix}/employees/excelExport`,
        fieldUsers: () => `${prefix}/employees/fieldUsers`,
        schedulers: () => `${prefix}/employees/schedulers`,
        superintendents: () => `${prefix}/employees/superintendents`,
    },
    employeeAccountStatus: {
        byId: (employeeAccountStatusId) =>
            `${prefix}/employeeAccountStatus/${employeeAccountStatusId}`,
        create: () => `${prefix}/employeeAccountStatus`,
        update: (employeeAccountStatusId) =>
            `${prefix}/employeeAccountStatus/${employeeAccountStatusId}`,
        delete: (employeeAccountStatusId) =>
            `${prefix}/employeeAccountStatus/${employeeAccountStatusId}`,
    },
    employeeAccountStatuses: {
        search: () => `${prefix}/employeeAccountStatuses/search`,
        all: () => `${prefix}/employeeAccountStatuses`,
    },
    employeeCompliances: {
        byId: (applicationUserComplianceId) =>
            `${prefix}/applicationUserCompliance/${applicationUserComplianceId}`,
        create: () => `${prefix}/applicationUserCompliance`,
        update: (applicationUserComplianceId) =>
            `${prefix}/applicationUserCompliance/${applicationUserComplianceId}`,
        delete: (applicationUserComplianceId) =>
            `${prefix}/applicationUserCompliance/${applicationUserComplianceId}`,
        allForEmployee: (employeeId) =>
            `${prefix}/applicationUserCompliances/getCompliancesForEmployee/${employeeId}`,
        search: () => `${prefix}/applicationUserCompliances/search/`,
    },
    employeeDailyAttendanceEvent: {
        byId: (id) => `${prefix}/employeeDailyAttendanceEvent/${id}`,
        upsert: () => `${prefix}/employeeDailyAttendanceEvent/upsert`,
        delete: () => `${prefix}/employeeDailyAttendanceEvent/delete`,
        allFor: () => `${prefix}/employeeDailyAttendanceEvents/allFor`,
    },
    employeeLongTermStatus: {
        allForEmployee: (employeeId) =>
            `${prefix}/employeeLongTermStatuses/${employeeId}`,
        byId: (id) => `${prefix}/employeeLongTermStatus/${id}`,
        create: () => `${prefix}/employeeLongTermStatus/create`,
        update: () => `${prefix}/employeeLongTermStatus/update`,
        delete: (id) => `${prefix}/employeeLongTermStatus/${id}`,
        allEffectiveBetween: () =>
            `${prefix}/employeeLongTermStatuses/allEffectiveBetween`,
    },
    employeeHistory: {
        byId: (empId) => `${prefix}/employeeHistory/${empId}`,
    },
    employeeGroupHistory: {
        byId: (empId) => `${prefix}/employeeGroupHistory/${empId}`,
    },
    employeeLocationHistory: {
        byId: (empId) => `${prefix}/employeeLocationHistory/${empId}`,
    },
    employeeLongTermStatusHistory: {
        byId: (empId) => `${prefix}/employeeLongTermStatusHistory/${empId}`,
    },
    employeePayRateHistory: {
        byId: (empId) => `${prefix}/employeePayRateHistory/${empId}`,
    },
    employeeRestrictionHistory: {
        byId: (empId) => `${prefix}/employeeRestrictionHistory/${empId}`,
    },
    equipment: {
        all: () => `${prefix}/equipments`,
        search: () => `${prefix}/equipments/search`,
        excelExport: () => `${prefix}/equipments/excelExport`,
        byId: (equipmentId) => `${prefix}/equipment/${equipmentId}`,
        byDispatchLocation: (companyId) =>
            `${prefix}/equipments/company/${companyId}`,
        byType: (typeId) => `${prefix}/equipments/${typeId}`,
        create: () => `${prefix}/equipment`,
        update: (equipmentId) => `${prefix}/equipment/${equipmentId}`,
        delete: (equipmentId) => `${prefix}/equipment/${equipmentId}`,
    },
    equipmentCompliances: {
        byId: (equipmentComplianceId) =>
            `${prefix}/equipmentCompliance/${equipmentComplianceId}`,
        create: () => `${prefix}/equipmentCompliance`,
        update: (equipmentComplianceId) =>
            `${prefix}/equipmentCompliance/${equipmentComplianceId}`,
        delete: (equipmentComplianceId) =>
            `${prefix}/equipmentCompliance/${equipmentComplianceId}`,
        allForEquipment: (equipmentId) =>
            `${prefix}/equipmentCompliances/getCompliancesFor/${equipmentId}`,
        search: () => `${prefix}/equipmentCompliances/search/`,
    },
    equipmentType: {
        all: () => `${prefix}/equipmentTypes`,
        search: () => `${prefix}/equipmentTypes/search`,
        byId: (equipmentTypeId) => `${prefix}/equipmentType/${equipmentTypeId}`,
        create: () => `${prefix}/equipmentType`,
        update: (equipmentTypeId) =>
            `${prefix}/equipmentType/${equipmentTypeId}`,
        delete: (equipmentTypeId) =>
            `${prefix}/equipmentType/${equipmentTypeId}`,
        requiringMoves: () => `${prefix}/equipmentTypes/requiringMoves`,
    },
    equipmentTypeCount: {
        forDate: (date) => `${prefix}/equipmentTypeCounts/${date}`,
        forDateRange: (startDate, endDate) =>
            `${prefix}/equipmentTypeCounts/range/${startDate}/${endDate}`,
    },
    equipmentGroup: {
        all: () => `${prefix}/equipmentGroups`,
        byId: (equipmentTypeId) =>
            `${prefix}/equipmentGroup/${equipmentTypeId}`,
        update: () => `${prefix}/equipmentGroup/update`,
    },
    equipmentStatus: {
        all: () => `${prefix}/equipmentStatuses`,
        search: () => `${prefix}/equipmentStatuses/search`,
        byId: (equipmentStatusId) =>
            `${prefix}/equipmentStatus/${equipmentStatusId}`,
        create: () => `${prefix}/equipmentStatus`,
        update: (equipmentStatusId) =>
            `${prefix}/equipmentStatus/${equipmentStatusId}`,
        delete: (equipmentStatusId) =>
            `${prefix}/equipmentStatus/${equipmentStatusId}`,
    },
    equipmentTypeStatus: {
        all: () => `${prefix}/equipmentTypeStatuses`,
        search: () => `${prefix}/equipmentTypeStatuses/search`,
        byId: (equipmentTypeId) =>
            `${prefix}/equipmentTypeStatus/${equipmentTypeId}`,
        create: () => `${prefix}/equipmentTypeStatus`,
        update: (equipmentTypeId) =>
            `${prefix}/equipmentTypeStatus/${equipmentTypeId}`,
        delete: (equipmentTypeId) =>
            `${prefix}/equipmentTypeStatus/${equipmentTypeId}`,
    },
    equipmentLocation: {
        anyFor: (equipmentId) =>
            `${prefix}/equipmentLocation/anyFor/${equipmentId}`,
        getFor: (equipmentId) =>
            `${prefix}/equipmentLocation/getFor/${equipmentId}`,
        for: (date) => `${prefix}/equipmentLocations/for/${date}`,
        move: () => `${prefix}/equipmentLocation/move`,
    },
    knownLocation: {
        all: () => `${prefix}/knownLocations`,
    },
    group: {
        all: () => `${prefix}/groups`,
        search: () => `${prefix}/groups/search`,
        byId: (groupId) => `${prefix}/group/${groupId}`,
        create: () => `${prefix}/group`,
        update: (groupId) => `${prefix}/group/${groupId}`,
        delete: (groupId) => `${prefix}/group/${groupId}`,
    },
    heavyBidImport: {
        import: () => `${prefix}/heavyBidImport/import`,
    },
    import: {
        arcGisOnline: () => `${prefix}/import/importArcGisOnline`,
        employees: () => `${prefix}/import/importEmployees`,
        companies: () => `${prefix}/import/importCompanies`,
        contracts: () => `${prefix}/import/importContracts`,
        equipment: () => `${prefix}/import/importEquipment`,
        equipmentTypes: () => `${prefix}/import/importEquipmentTypes`,
    },
    importTracker: {
        systems: () => `${prefix}/importSystems`,
        statuses: () => `${prefix}/importTrackerStatuses`,
        all: (importSystemId) =>
            importSystemId
                ? `${prefix}/importTrackers/${importSystemId}`
                : `${prefix}/importTrackers/`,
    },
    vistaImport: {
        start: () => `${prefix}/vistaImport/start`,
    },
    invoice: {
        streamCTRFile: (invoiceId) =>
            `${prefix}/invoice/streamCTRFile/${invoiceId}`,
        streamProofOf40File: (invoiceId) =>
            `${prefix}/invoice/streamProofOf40File/${invoiceId}`,
        streamInvoice: (invoiceId) =>
            `${prefix}/invoice/streamInvoice/${invoiceId}`,
        streamInvoiceTimesheets: (invoiceId) =>
            `${prefix}/invoice/streamInvoiceTimesheets/${invoiceId}`,
        draft: (invoiceId) => `${prefix}/invoice/draft/${invoiceId}`,
        draftTimesheetDelete: () => `${prefix}/invoice/draftTimesheetDelete`,
        approve: (invoiceId) => `${prefix}/invoice/approve/${invoiceId}`,
        revert: (invoiceId) => `${prefix}/invoice/revert/${invoiceId}`,
        create: () => `${prefix}/invoice`,
        update: (invoiceId) => `${prefix}/invoice/${invoiceId}`,
        restart: (invoiceId) => `${prefix}/invoice/restart/${invoiceId}`,
        delete: (invoiceId) => `${prefix}/invoice/${invoiceId}`,
        byId: (invoiceId) => `${prefix}/invoice/${invoiceId}`,
        search: () => `${prefix}/invoices/search`,
        timesheets: (contractId, workorderNumber, weekDate) =>
            `${prefix}/invoices/timesheets/${contractId}/${workorderNumber}/${weekDate}`,
        ctrexport: (id) => `${prefix}/invoice/ctrexport/${id}`,
        proofof40: (id) => `${prefix}/invoice/proofof40/${id}`,
        downloadInvoiceTimesheets: (id) =>
            `${prefix}/invoice/downloadInvoiceTimesheets/${id}`,
        emailInvoice: (id) => `${prefix}/invoice/emailInvoice/${id}`,
        downloadInvoice: (id) => `${prefix}/invoice/downloadInvoice/${id}`,
        streamInvoices: (ids) => `${prefix}/invoices/streamInvoices/${ids}`,
        exportToNetSuite: () => `${prefix}/invoices/exporttonetsuite`,
        exportToQuickbooks: () => `${prefix}/invoices/exporttoquickbooks`,
        clearExport: () => `${prefix}/invoices/clearexport`,
        downloadInvoices: () => `${prefix}/invoices/downloadinvoices`,
        getExportFile: (id, type) =>
            `${prefix}/invoices/getexportfile/${id}/${type}`,
        getCMExportFiles: () => `${prefix}/invoices/getcreditmemofiles`,
        invoiceExportsToClear: (id) =>
            `${prefix}/invoices/invoiceexportstoclear/${id}`,
        excelExport: () => `${prefix}/invoices/excelExport`,
        slideoutStaff: (dispLocationId) =>
            `${prefix}/invoice/slideoutStaff/${dispLocationId}`,
        slideoutEquipment: (dispLocationId) =>
            `${prefix}/invoice/slideoutEquipment/${dispLocationId}`,
    },
    invoiceGeneration: {
        search: () => `${prefix}/invoiceGenerations/search`,
        excelExport: () => `${prefix}/invoiceGenerations/excelExport`,
        export: () => `${prefix}/invoiceGenerations/export`,
        reject: () => `${prefix}/invoiceGenerations/reject`,
        billingReject: () => `${prefix}/invoiceGenerations/billingReject`,
        adminReject: () => `${prefix}/invoiceGenerations/adminReject`,
        needsAdminReject: (id) =>
            `${prefix}/invoiceGenerations/needsAdminReject/${id}`,
        download: (id) => `${prefix}/invoiceGeneration/download/${id}`,
        setEmergency: () => `${prefix}/invoiceGeneration/setEmergency`,
        setOnHold: () => `${prefix}/invoiceGeneration/setOnHold`,
        removeOnHold: () => `${prefix}/invoiceGeneration/removeOnHold`,
        generateChargeReport: () =>
            `${prefix}/invoiceGenerations/generateChargeReport`,
    },
    localization: {
        strings: () => `${prefix}/localization/strings`,
    },
    locationContact: {
        all: () => `${prefix}/locationContacts`,
        byId: (id) => `${prefix}/locationContact/${id}`,
        create: () => `${prefix}/locationContact`,
        update: (id) => `${prefix}/locationContact/${id}`,
        search: () => `${prefix}/locationContacts/search`,
        forJob: (jobId) => `${prefix}/locationContacts/forJob/${jobId}`,
        excelExport: () => `${prefix}/locationContacts/excelExport`,
    },
    longTermSchedule: {
        all: () => `${prefix}/longTermSchedules`,
        create: () => `${prefix}/longTermSchedule/create`,
        createJobs: () => `${prefix}/longTermSchedule/createJobs`,
        delete: (id) => `${prefix}/longTermSchedule/${id}`,
        search: () => `${prefix}/longTermSchedules/search`,
        getActiveDayCount: () => `${prefix}/longTermSchedule/getActiveDayCount`,
        getConflicts: () => `${prefix}/longTermSchedule/getConflicts`,
        getDateOverview: (id) =>
            `${prefix}/longTermSchedule/getDateOverview/${id}`,
        getForContract: (contractId) =>
            `${prefix}/longTermSchedules/forContract/${contractId}`,
        getMaxCrewEndDate: (crewId) =>
            `${prefix}/longTermSchedule/getMaxCrewEndDate/${crewId}`,
        getSingle: (longTermScheduleId) =>
            `${prefix}/longTermSchedule/${longTermScheduleId}`,
        searchUnassignedCrews: () =>
            `${prefix}/longTermSchedules/searchUnassignedCrews`,
        release: (id, date) =>
            `${prefix}/longTermSchedule/release/${id}/${date}`,
        update: () => `${prefix}/longTermSchedule/update`,
        markAssigned: (longTermScheduleId) =>
            `${prefix}/longTermSchedule/markAssigned/${longTermScheduleId}`,
    },
    longTermScheduleCancellation: {
        getOptions: () => `${prefix}/longTermScheduleCancellation/getOptions`,
        get: (longTermScheduleId, date) =>
            `${prefix}/longTermScheduleCancellation/${longTermScheduleId}/${date}`,
        cancelDay: () => `${prefix}/longTermScheduleCancellation/cancelDay`,
        search: () => `${prefix}/longTermScheduleCancellations/search`,
        check: (longTermScheduleId, date) =>
            `${prefix}/longTermScheduleCancellation/check/${longTermScheduleId}/${date}`,
    },
    longTermStatus: {
        all: () => `${prefix}/longTermStatuses`,
        byId: (id) => `${prefix}/longTermStatus/${id}`,
        create: () => `${prefix}/longTermStatus/create`,
        update: () => `${prefix}/longTermStatus/update`,
        search: () => `${prefix}/longTermStatuses/search`,
        delete: (id) => `${prefix}/longTermStatus/${id}`,
    },
    userGroup: {
        all: () => `${prefix}/userGroups`,
        search: () => `${prefix}/userGroups/search`,
        byId: (userGroupId) => `${prefix}/userGroup/${userGroupId}`,
        create: () => `${prefix}/userGroup`,
        update: (userGroupId) => `${prefix}/userGroup/${userGroupId}`,
        delete: (userGroupId) => `${prefix}/userGroup/${userGroupId}`,
    },
    permission: {
        all: () => `${prefix}/permissions`,
        search: () => `${prefix}/permissions/search`,
        byId: (permissionId) => `${prefix}/permission/${permissionId}`,
        create: () => `${prefix}/permission`,
        update: (permissionId) => `${prefix}/permission/${permissionId}`,
        delete: (permissionId) => `${prefix}/permission/${permissionId}`,
    },
    job: {
        weeks: () => `${prefix}/jobs/weeks`,
        search: () => `${prefix}/jobs/search`,
        dailyView: () => `${prefix}/jobs/dailyView`,
        dailyViewHistory: () => `${prefix}/jobs/dailyViewHistory`,
        dailyViewExcelExport: () => `${prefix}/jobs/dailyViewExcelExport`,
        dailyViewHistoryExcelExport: () =>
            `${prefix}/jobs/dailyViewHistoryExcelExport`,
        byId: (jobId) => `${prefix}/job/${jobId}`,
        byContractId: (contractId) => `${prefix}/job/${contractId}`,
        getResources: (contractId) =>
            `${prefix}/job/getJobResources/${contractId}`,
        getNonResources: (contractId) =>
            `${prefix}/job/getJobNonResources/${contractId}`,
        create: () => `${prefix}/job`,
        update: (jobId) => `${prefix}/job/${jobId}`,
        updateForLts: (jobId) => `${prefix}/job/updateForLts/${jobId}`,
        delete: (jobId) => `${prefix}/job/${jobId}`,
        postAttachments: (jobId) => `${prefix}/job/${jobId}/attach`,
        attachment: (jobId) => `${prefix}/job/${jobId}/attachment`,
        getAllAttachments: (jobId) => `${prefix}/job/${jobId}/attachments`,
        getTimesheetStatus: (jobId) => `${prefix}/timesheetStatus/${jobId}`,
        getPublishedJob: (longTermScheduleId, eventDate) =>
            `${prefix}/job/getPublishedJob/${longTermScheduleId}/${eventDate}`,
        addAdditionalResources: () => `${prefix}/job/addAdditionalResources`,
    },
    jobAssignment: {
        byId: (assignmentId) => `${prefix}/jobAssignment/${assignmentId}`,
        confirm: (assignmentId) =>
            `${prefix}/jobAssignment/confirm/${assignmentId}`,
        notify: () => `${prefix}/jobAssignments/notify`,
        setEmergency: () => `${prefix}/jobAssignments/setEmergency`,
        eventLog: () => `${prefix}/jobAssignments/eventLog`,
        anyNotificationsSent: () =>
            `${prefix}/jobAssignment/anyNotificationsSent`,
    },
    jobAssignmentCancellation: {
        byId: (assignmentCancellationId) =>
            `${prefix}/jobAssignmentCancellation/${assignmentCancellationId}`,
        cancelConfirmed: (assignmentCancellationId) =>
            `${prefix}/jobAssignmentCancellation/cancelConfirmed/${assignmentCancellationId}`,
    },
    jobAssignmentCancellationType: {
        byId: (id) => `${prefix}/jobAssignmentCancellationType/${id}`,
        all: () => `${prefix}/jobAssignmentCancellationTypes/all`,
        search: () => `${prefix}/jobAssignmentCancellationTypes/search`,
        create: () => `${prefix}/jobAssignmentCancellationType/create`,
        update: () => `${prefix}/jobAssignmentCancellationType/update`,
        delete: (id) => `${prefix}/jobAssignmentCancellationType/${id}`,
    },
    jobOverride: {
        get: (longTermScheduleId, date) =>
            `${prefix}/jobOverride/get/${longTermScheduleId}/${date}`,
        upsert: (longTermScheduleId) =>
            `${prefix}/jobOverride/upsert/${longTermScheduleId}`,
    },
    locationContactType: {
        all: () => `${prefix}/locationContactTypes`,
    },
    locationType: {
        search: () => `${prefix}/locationTypes/search`,
        byId: (locationTypeId) => `${prefix}/locationType/${locationTypeId}`,
        create: () => `${prefix}/locationType`,
        update: (locationTypeId) => `${prefix}/locationType/${locationTypeId}`,
        delete: (locationTypeId) => `${prefix}/locationType/${locationTypeId}`,
    },
    paySchedule: {
        search: () => `${prefix}/payrollManagements/searchPaySchedules`,
        all: () => `${prefix}/payrollManagements/paySchedules`,
        byId: (payScheduleId) =>
            `${prefix}/payrollManagements/paySchedule/${payScheduleId}`,
        update: (payScheduleId) =>
            `${prefix}/payrollManagements/paySchedule/${payScheduleId}`,
    },
    payroll: {
        search: () => `${prefix}/payrolls/search`,
        searchindividual: () => `${prefix}/payrolls/searchindividual`,
        searchfullview: () => `${prefix}/payrolls/searchfullview`,
        excelExport: () => `${prefix}/payrolls/excelExport`,
        excelExportIndividual: () => `${prefix}/payrolls/excelExportIndividual`,
        approve: () => `${prefix}/payrolls/approve`,
        export: () => `${prefix}/payrolls/export`,
        payrollReject: () => `${prefix}/payrolls/payrollReject`,
        excelWeeklyExport: () => `${prefix}/payrolls/excelWeeklyExport`,
        excelHoursExport: () => `${prefix}/payrolls/excelHoursExport`,
        employees: () => `${prefix}/payrolls/employees`,
        download: (id) => `${prefix}/payroll/download/${id}`,
        downloadWeekly: (id) => `${prefix}/payroll/downloadWeekly/${id}`,
        edit: () => `${prefix}/payroll/edit`,
        doesPayrollHaveEdits: () => `${prefix}/payroll/doesPayrollHaveEdits`,
        doesPayrollHaveExports: () =>
            `${prefix}/payroll/doesPayrollHaveExports`,
    },
    payrollManagement: {
        search: () => `${prefix}/payrollManagements/search`,
        excelExport: () => `${prefix}/payrollManagements/excelExport`,
        slideout: (payrollId) =>
            `${prefix}/payrollManagement/${payrollId}/slideout`,
        edit: () => `${prefix}/payrollManagement/edit`,
        approve: () => `${prefix}/payrollManagements/approve`,
        process: () => `${prefix}/payrollManagements/process`,
        adminReject: () => `${prefix}/payrollManagements/adminReject`,
        needsAdminReject: (id) =>
            `${prefix}/payrollManagements/needsAdminReject/${id}`,
        reject: () => `${prefix}/payrollManagements/reject`,
        download: (id) => `${prefix}/payrollManagement/download/${id}`,
        downloadWeekly: (id) =>
            `${prefix}/payrollManagement/downloadWeekly/${id}`,
        setEmergency: () => `${prefix}/payrollManagement/setEmergency`,
        recalculateWeek: () => `${prefix}/payrollManagement/recalculateWeek`,
    },
    contractPhases: {
        allForContract: (contractId, longTermScheduleToIgnoreId) =>
            `${prefix}/contractPhases/all/${contractId}/${longTermScheduleToIgnoreId}`,
        forContract: (contractId, longTermScheduleToIgnoreId) =>
            `${prefix}/contractPhases/${contractId}/${longTermScheduleToIgnoreId}`,
        toggleHidden: (contractPhaseId) =>
            `${prefix}/contractPhase/toggleHidden/${contractPhaseId}`,
    },
    phaseMaterials: {
        forContract: (contractId) => `${prefix}/phaseMaterials/${contractId}`,
    },
    heavyBidMaterials: {
        forContract: (contractId) =>
            `${prefix}/heavyBidMaterials/${contractId}`,
    },
    lowboyAssignment: {
        for: (dateString) => `${prefix}/lowboyAssignments/for/${dateString}`,
        add: () => `${prefix}/lowboyAssignment/add`,
        remove: (lowboyAssignmentId) =>
            `${prefix}/lowboyAssignment/remove/${lowboyAssignmentId}`,
        notify: (dateString) =>
            `${prefix}/lowboyAssignments/notify/${dateString}`,
        reorder: () => `${prefix}/lowboyAssignments/reorder`,
        dispatches: (dateString) =>
            `${prefix}/lowboyAssignments/dispatches/${dateString}`,
        confirm: (dateString) =>
            `${prefix}/lowboyAssignments/confirm/${dateString}`,
        associatedWith: (lowboyTimesheetId) =>
            `${prefix}/lowboyAssignments/associatedWith/${lowboyTimesheetId}`,
    },
    lowboyResource: {
        update: () => `${prefix}/lowboyResource/update`,
        for: (dateString) => `${prefix}/lowboyResources/for/${dateString}`,
        counts: (startDateString, endDateString) =>
            `${prefix}/lowboyResources/counts/${startDateString}/${endDateString}`,
    },
    lowboyEquipmentType: {
        getIdsRequiringMoves: () => `${prefix}/lowboyEquipmentTypes/getIds`,
    },
    lowboyEquipment: {
        all: () => `${prefix}/lowboyEquipments`,
        moves: (startDateString, endDateString) =>
            `${prefix}/lowboyEquipments/moves/${startDateString}/${endDateString}`,
    },
    lowboyCargo: {
        add: () => `${prefix}/lowboyCargo/add`,
        remove: (lowboyCargoId) => `${prefix}/lowboyCargo/${lowboyCargoId}`,
    },
    lowboyEmployee: {
        for: (dateString) => `${prefix}/lowboyEmployees/for/${dateString}`,
    },
    lowboyTimesheet: {
        getIdFor: (date) => `${prefix}/lowboyTimesheet/idFor/${date}`,
        get: (lowboyTimesheetId) =>
            `${prefix}/lowboyTimesheet/${lowboyTimesheetId}`,
        save: () => `${prefix}/lowboyTimesheet/save`,
        submit: () => `${prefix}/lowboyTimesheet/submit`,
        recallForEdit: (lowboyTimesheetId) =>
            `${prefix}/lowboyTimesheet/recallForEdit/${lowboyTimesheetId}`,
    },
    lowboyTimesheetManagement: {
        accept: (lowboyTimesheetId) =>
            `${prefix}/lowboyTimesheetManagement/accept/${lowboyTimesheetId}`,
        reject: () => `${prefix}/lowboyTimesheetManagement/reject`,
    },
    arcGisLocations: {
        forContract: (contractId) => `${prefix}/arcGisLocations/${contractId}`,
        activeForContract: (contractId) =>
            `${prefix}/arcGisLocations/active/${contractId}`,
        forTimesheet: (timesheetId) =>
            `${prefix}/arcGisLocation/timesheet/${timesheetId}`,
        forAssignment: (jobAssignmentId) =>
            `${prefix}/arcGisLocation/assignment/${jobAssignmentId}`,
    },
    quickbooks: {
        search: () => `${prefix}/quickBooksInventoryItems/search`,
        create: () => `${prefix}/quickBooksInventoryItem/new`,
        update: (qbiId) => `${prefix}/quickBooksInventoryItem/${qbiId}`,
        edit: (qbiId) => `${prefix}/quickBooksInventoryItem/${qbiId}`,
        excelExport: () => `${prefix}/quickBooksInventoryItems/excelExport`,
    },
    report: {
        timesheet: (timesheetId) => `${prefix}/report/timesheet/${timesheetId}`,
        timesheetBilling: (timesheetId) =>
            `${prefix}/report/timesheet/${timesheetId}/billing`,
        timesheetPayroll: (timesheetId) =>
            `${prefix}/report/timesheet/${timesheetId}/payroll`,
        timesheetPayrollIndividual: (timesheetId) =>
            `${prefix}/report/timesheet/${timesheetId}/payrollIndividual`,
        invoice: (invoiceId) => `${prefix}/report/invoice/${invoiceId}`,
        newCustomerBillableHours: () =>
            `${prefix}/report/newCustomerBillableHours`,
        staffing: () => `${prefix}/report/staffing`,
        expiringContract: () => `${prefix}/report/expiringContract`,
    },
    role: {
        all: () => `${prefix}/roles`,
        search: () => `${prefix}/roles/search`,
        byId: (roleId) => `${prefix}/role/${roleId}`,
        create: () => `${prefix}/role`,
        update: (roleId) => `${prefix}/role/${roleId}`,
        delete: (roleId) => `${prefix}/role/${roleId}`,
    },
    selfDispatchTimesheet: {
        byId: (id) => `${prefix}/selfDispatchTimesheet/${id}`,
        equipmentByChargeType: (chargeTypeId) =>
            `${prefix}/selfDispatchTimesheet/equipment/${chargeTypeId}`,
        create: () => `${prefix}/selfDispatchTimesheet`,
        selfDispatchNotifications: () =>
            `${prefix}/selfDispatchTimesheet/selfDispatchNotifications`,
        nonFlagNotifications: () =>
            `${prefix}/selfDispatchTimesheet/nonFlagNotifications`,
        count: () => `${prefix}/selfDispatchTimesheet/count`,
    },
    tenant: {
        all: () => `${prefix}/tenants/all`,
        byId: (companyId) => `${prefix}/tenant/${companyId}`,
        search: () => `${prefix}/tenants/search`,
        settings: () => `${prefix}/tenant/settings`,
        viewModel: () => `${prefix}/tenants/viewModel`,
        invalidPhoneNumbers: () => `${prefix}/tenant/invalidphonenumbers`,
        optionalCompanyTypes: () => `${prefix}/tenant/optionalCompanyTypes`,
        countyCaptureTypes: () => `${prefix}/tenant/countyCaptureTypes`,
        getLogo: () => `${prefix}/tenant/logo`,
        updateBrandLogo: (tenantId) =>
            `${prefix}/tenant/${tenantId}/updateBrandLogo`,
        updateReportLogo: (tenantId) =>
            `${prefix}/tenant/${tenantId}/updateReportLogo`,
    },
    crewTimesheet: {
        get: (timesheetId) => `${prefix}/crewTimesheet/${timesheetId}`,
        getJobDetails: (timesheetId) =>
            `${prefix}/crewTimesheet/jobDetails/${timesheetId}`,
        update: () => `${prefix}/crewTimesheet/update`,
        submit: () => `${prefix}/crewTimesheet/submit`,
        recall: (timesheetId) =>
            `${prefix}/crewTimesheet/recall/${timesheetId}`,
    },
    absenceReason: {
        getAll: () => `${prefix}/absenceReasons`,
    },
    timesheet: {
        overview: (timesheetId) =>
            `${prefix}/timesheet/${timesheetId}/overview`,
        slideout: (timesheetId, payroll, billing) =>
            `${prefix}/timesheet/${timesheetId}/slideout?payroll=${payroll}&billing=${billing}`,
        slideoutStaff: (dispLocationId) =>
            `${prefix}/timesheet/slideoutStaff/${dispLocationId}`,
        slideoutEquipment: (dispLocationId) =>
            `${prefix}/timesheet/slideoutEquipment/${dispLocationId}`,
        byId: (timesheetId) => `${prefix}/timesheet/${timesheetId}`,
        byEmp: (timesheetId, empId) =>
            `${prefix}/timesheet/${timesheetId}?empId=${empId}`,
        update: () => `${prefix}/timesheet/updateTimesheet`,
        createLinkedTimesheet: (parentId) =>
            `${prefix}/timesheet/createLinkedTimesheet/${parentId}`,
        updateWorkOrderNumber: (id) =>
            `${prefix}/timesheet/${id}/workOrderNumber`,
        undoClientCancel: () => `${prefix}/timesheet/undoClientCancel`,
        updateForeman: (id) => `${prefix}/timesheet/${id}/foreman`,
        updateRequestor: (id) => `${prefix}/timesheet/${id}/requestor`,
        setEmergency: () => `${prefix}/timesheet/setEmergency`,
        byEmployeeSearch: () => `${prefix}/timesheets/searchByEmployee`,
        timesheetDashboard: () => `${prefix}/timesheets/getDashboard`,
        audit: () => `${prefix}/timesheet/audit`,
        rollBackApproved: (timesheetId) =>
            `${prefix}/timesheet/${timesheetId}/rollBackApproved`,
        rollBackExported: (timesheetId) =>
            `${prefix}/timesheet/${timesheetId}/rollBackExported`,
    },
    timesheetReview: {
        byId: (reviewId) => `${prefix}/timesheetReview/${reviewId}`,
        update: () => `${prefix}/timesheetReview/updateTimesheetReview`,
        clientByTimesheetId: (timesheetId) =>
            `${prefix}/timesheetReview/client/${timesheetId}`,
        employeesByTimesheetId: (timesheetId) =>
            `${prefix}/timesheetReview/employee/${timesheetId}`,
        missingSignatureReasons: () =>
            `${prefix}/timesheetReview/missingSignatureReasons`,
    },
    timesheetManagement: {
        search: () => `${prefix}/timesheetManagements/search`,
        export: () => `${prefix}/timesheetManagements/export`,
        download: (id) => `${prefix}/timesheetManagement/download/${id}`,
        excelExport: () => `${prefix}/timesheetManagements/excelExport`,
        accept: (timesheetId) =>
            `${prefix}/timesheetManagement/accept/${timesheetId}`,
        modify: (timesheetId) =>
            `${prefix}/timesheetManagement/modify/${timesheetId}`,
        reject: () => `${prefix}/timesheetManagement/reject`,
        softDelete: () => `${prefix}/timesheetManagement/softDelete`,
        timesheetsBelongingToJobs: (ids) =>
            `${prefix}/timesheetManagement/timesheetsBelongingToJobs/${ids}`,
    },
    contractTimesheetManagement: {
        search: () => `${prefix}/contractTimesheetManagements/search`,
        export: () => `${prefix}/contractTimesheetManagements/export`,
    },
    timeOffReasons: {
        all: () => `${prefix}/timeOffReasons`,
    },
    timeOffRequests: {
        my: () => `${prefix}/timeOffRequests/my`,
        get: (timeOffRequestId) =>
            `${prefix}/timeOffRequest/get/${timeOffRequestId}`,
        save: () => `${prefix}/timeOffRequest/save`,
        submit: () => `${prefix}/timeOffRequest/submit`,
        recallForEdit: (timeOffRequestId) =>
            `${prefix}/timeOffRequest/recallForEdit/${timeOffRequestId}`,
    },
    timeOffRequestManagement: {
        reject: () => `${prefix}/timeOffRequestManagement/reject`,
        accept: (timeOffRequestId) =>
            `${prefix}/timeOffRequestManagement/accept/${timeOffRequestId}`,
    },
    dailyTimesheets: {
        getRangeFor: (startDateString, endDateString) =>
            `${prefix}/dailyTimesheets/getFor/${startDateString}/${endDateString}`,
        getFor: (dateString) => `${prefix}/dailyTimesheet/getFor/${dateString}`,
        get: (dailyTimesheetId) =>
            `${prefix}/dailyTimesheet/get/${dailyTimesheetId}`,
        save: () => `${prefix}/dailyTimesheet/save`,
        submit: () => `${prefix}/dailyTimesheet/submit`,
        recall: (dailyTimesheetId) =>
            `${prefix}/dailyTimesheet/recall/${dailyTimesheetId}`,
        delete: (dailyTimesheetId) =>
            `${prefix}/dailyTimesheet/delete/${dailyTimesheetId}`,
    },
    dailyTimesheetManagement: {
        reject: () => `${prefix}/dailyTimesheetManagement/reject`,
        accept: (dailyTimesheetId) =>
            `${prefix}/dailyTimesheetManagement/accept/${dailyTimesheetId}`,
    },
    USStates: () => `${prefix}/usstates`,
    USCounties: {
        all: () => `${prefix}/usCounties`,
        groups: () => `${prefix}/usCounties/groups`,
        groupTypes: () => `${prefix}/usCounties/groupTypes`,
        byGroupId: (id) => `${prefix}/usCounties/group/${id}`,
        group: () => `${prefix}/usCounties/group`,
    },
    typeAheads: {
        jobCities: (partialTextSearch) =>
            `${prefix}/typeahead/getJobCities/${partialTextSearch}`,
        companies: () => `${prefix}/typeahead/getCompanies`,
        customers: () => `${prefix}/typeahead/getCustomers`,
        parentCustomers: () => `${prefix}/typeahead/getParentCustomers`,
        subcontractingCustomers: () =>
            `${prefix}/typeahead/getSubcontractingCustomers`,
        billingCompanies: () => `${prefix}/typeahead/getBillingCompanies`,
        contracts: () => `${prefix}/typeahead/getContracts`,
        contractsSearch: (partialTextSearch) =>
            `${prefix}/typeahead/getContractNumber/${partialTextSearch}`,
        contractsByCompany: (companyId) =>
            `${prefix}/typeahead/getContractsByCompany/${companyId}`,
        companyChargeTypeGroups: (companyId) =>
            `${prefix}/typeahead/getCompanyChargeTypeGroups/${companyId}`,
        billingChargeTypes: (timesheetId) =>
            `${prefix}/typeahead/getBillingChargeTypes/${timesheetId}`,
        billingContacts: (companyId) =>
            `${prefix}/typeahead/getBillingContacts/${companyId}`,
        dispatchLocations: () => `${prefix}/typeahead/getDispatchLocations`,
        dispatchCompanies: () => `${prefix}/typeahead/getDispatchCompanies`,
        payrollCompanies: () => `${prefix}/typeahead/getPayrollCompanies`,
        companyTypes: () => `${prefix}/typeahead/getCompanyTypes`,
        companyStatuses: () => `${prefix}/typeahead/getCompanyStatus`,
        contractStatuses: () => `${prefix}/typeahead/getContractStatus`,
        chargeTypeUnits: () => `${prefix}/typeahead/getChargeTypeUnits`,
        chargeTypes: () => `${prefix}/typeahead/getChargeTypes`,
        chargeTypeSearch: (partialTextSearch) =>
            `${prefix}/typeahead/getChargeTypes/${partialTextSearch}`,
        chargeTypesBillable: () => `${prefix}/typeahead/getChargeTypesBillable`,
        chargeTypeApplicability: () =>
            `${prefix}/typeahead/getChargeTypeApplicability`,
        chargeTypesNonBillable: () =>
            `${prefix}/typeahead/getChargeTypesNonBillable`,
        employeeComplianceTypes: () =>
            `${prefix}/typeahead/getEmployeeComplianceTypes`,
        employeeGroups: () => `${prefix}/typeahead/getEmployeeGroups`,
        employees: () => `${prefix}/typeahead/getEmployees`,
        equipmentComplianceTypes: () =>
            `${prefix}/typeahead/getEquipmentComplianceTypes`,
        equipmentTypes: () => `${prefix}/typeahead/getEquipmentTypes`,
        equipmentTypeAFADTypes: () =>
            `${prefix}/typeahead/getEquipmentTypeAFADTypes`,
        equipmentTypeStatuses: () =>
            `${prefix}/typeahead/getEquipmentTypeStatuses`,
        locationTypes: () => `${prefix}/typeahead/getLocationTypes`,
        permissions: () => `${prefix}/typeahead/getPermissions`,
        pendingBillingTimesheets: () =>
            `${prefix}/typeahead/getPendingBillingTimesheets`,
        pendingPayrollTimesheets: () =>
            `${prefix}/typeahead/getPendingPayrollTimesheets`,
        roles: () => `${prefix}/typeahead/getRoles`,
        USStates: () => `${prefix}/typeahead/getUSStates`,
        crewSignatureTypes: () => `${prefix}/typeahead/getCrewSignatureTypes`,
        clientSignatureTypes: () =>
            `${prefix}/typeahead/getClientSignatureTypes`,
        jobAssignmentCancellationTypes: () =>
            `${prefix}/typeahead/getJobAssignmentCancellationTypes`,
        jobCancellationTypes: () =>
            `${prefix}/typeahead/getJobCancellationTypes`,
        timesheetNumberSearch: (partialTextSearch) =>
            `${prefix}/typeahead/getTimesheetNumber/${partialTextSearch}`,
        timesheetStatuses: () => `${prefix}/typeahead/getTimesheetStatuses`,
        timesheetDetails: (timesheetId) =>
            `${prefix}/typeahead/getTimesheetDetails/${timesheetId}`,
        payrollStatuses: () => `${prefix}/typeahead/getPayrollStatuses`,
        timesheetManagementStatuses: () =>
            `${prefix}/typeahead/getTimesheetManagementStatuses`,
        timesheetBillingStatuses: () =>
            `${prefix}/typeahead/getTimesheetBillingStatuses`,
        billingStatuses: () => `${prefix}/typeahead/getBillingStatuses`,
        billingChargeStatuses: () =>
            `${prefix}/typeahead/getBillingChargeStatuses`,
        operationsCenters: () => `${prefix}/typeahead/getOperationsCenters`,
        subcontractors: (customerId) =>
            `${prefix}/typeahead/getSubcontractors/${customerId}`,
        billingChargeFlags: () => `${prefix}/typeahead/getBillingChargeFlags`,
        billingCategoryFlags: () =>
            `${prefix}/typeahead/getBillingCategoryFlags`,
        payrollChargeFlags: () => `${prefix}/typeahead/getPayrollChargeFlags`,
        payrollCategoryFlags: () =>
            `${prefix}/typeahead/getPayrollCategoryFlags`,
        payrollChargeTypes: (timesheetId) =>
            `${prefix}/typeahead/getPayrollChargeTypes/${timesheetId}`,
        invoiceTerms: () => `${prefix}/typeahead/getInvoiceTerms`,
        invoiceMapping: () => `${prefix}/typeahead/getInvoiceMapping`,
        invoiceStatuses: () => `${prefix}/typeahead/getInvoiceStatuses`,
        activityTaskStatuses: () =>
            `${prefix}/typeahead/getActivityTaskStatuses`,
        activityTaskTypes: () => `${prefix}/typeahead/getActivityTaskTypes`,
        taskInteractionTypes: () =>
            `${prefix}/typeahead/getTaskInteractionTypes`,
        chargeTypeGroups: () => `${prefix}/typeahead/getChargeTypeGroups`,
        quickBooksSalesAccounts: () =>
            `${prefix}/typeahead/getQuickBooksInventoryItemSalesAccounts`,
        quickBooksInventoryItems: () =>
            `${prefix}/typeahead/getQuickBooksInventoryItems`,
        serviceItems: () => `${prefix}/typeahead/getServiceItems`,
        costCodes: () => `${prefix}/typeahead/getCostCodes`,
        materials: () => `${prefix}/typeahead/getMaterials`,
        contractMaterials: (contractId) =>
            `${prefix}/typeahead/getContractMaterials/${contractId}`,
    },
    workOrders: {
        all: () => `${prefix}/workorders`,
    },
};
